module.exports = __webpack_public_path__ + "static/media/energy4.25f2c904.jpeg";